import { Box } from '@mui/material';
import React from 'react';
import GlobalCallout from '../../components/Global/CalloutDefault';
import Hero from '../../components/Hero/Hero';
import Image from '../../components/Image/Image';
import Metadata from '../../components/Metadata/Metadata';
import Pathfinder from '../../components/Pathfinder/Pathfinder';
import Section from '../../components/Section/Section';

const PageContent: React.FC = () => {
  return (
    <Box>
      <Metadata
        title="Data Portal | General Genomics"
        description="Explore General Genomics' Data Portal to discover synthetic and de-identified datasets. Learn how our tailored data solutions address challenges across industries like government, healthcare, and bioinformatics."
      />
      <Hero
        helper="Data Portal"
        headline="Access synthetic data through our secure portal"
      />

      <Section theme="light" className="cards-large-icons">
        <h2 className="action-on-view action-fade-in">
          Unlock Insights with Our Data Portal – Coming Soon!
        </h2>
        <p className="action-on-view action-fade-in">
          Get ready to transform data into actionable insights. General
          Genomics&apos; Data Portal is launching soon, designed to empower
          businesses with secure, scalable, and compliant data solutions.
          Utilizing SYN46™ synthetic datasets, our platform will address key
          challenges in healthcare, government, and bioinformatics. Stay tuned
          to discover how you can unlock powerful insights tailored to your
          needs while ensuring data integrity and compliance.
        </p>
        <Image
          path="/images/library/lab-technicians-group-laptop-4.webp"
          size="wide"
          className="action-on-view action-fade-in"
          alt="This is a wide image."
        />
      </Section>

      <GlobalCallout />

      <Pathfinder />
    </Box>
  );
};

export default PageContent;
